import { OutputLifecycleSurveyDoNotContactList } from '~/gql/graphql';

type TransformedLifecycleSurveyDoNotContactList = OutputLifecycleSurveyDoNotContactList & {
  name: string;
  addedByUserName: string;
  reason: string;
};

const lifecycleSurveyDoNotContactListTransformer = (
  data: OutputLifecycleSurveyDoNotContactList,
): TransformedLifecycleSurveyDoNotContactList => {
  return {
    ...data,
    name: `${data?.firstName} ${data?.lastName}`,
    addedByUserName: `${data?.addedByUser?.firstName} ${data?.addedByUser?.lastName}`,
    reason: data?.doNotContactReason ?? '',
  };
};

export { lifecycleSurveyDoNotContactListTransformer, type TransformedLifecycleSurveyDoNotContactList };
